import { FormattedMessage } from 'react-intl';
import { Grid } from '@material-ui/core';
import { WikusButton } from '@wikus-ui/components/core/button';

export interface StorageFilterProps {
  selectedCategory: string;
  onChange: (category: string) => void;
}

export const StorageFilter = ({ selectedCategory, onChange }: StorageFilterProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedCategory === '' ? 'contained' : 'outlined'}
          onClick={() => onChange('')}>
          <FormattedMessage id="storage.filter.category.all" />
        </WikusButton>
      </Grid>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedCategory === 'band' ? 'contained' : 'outlined'}
          onClick={() => onChange('band')}>
          <FormattedMessage id="storage.filter.category.band" />
        </WikusButton>
      </Grid>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedCategory === 'roll' ? 'contained' : 'outlined'}
          onClick={() => onChange('roll')}>
          <FormattedMessage id="storage.filter.category.roll" />
        </WikusButton>
      </Grid>
      <Grid item>
        <WikusButton
          color="primary"
          variant={selectedCategory === 'custom' ? 'contained' : 'outlined'}
          onClick={() => onChange('custom')}>
          <FormattedMessage id="storage.filter.category.custom" />
        </WikusButton>
      </Grid>
    </Grid>
  );
};
